{
  "version": 1,
  "asset_id": "b60ff497-0c81-423d-83a4-7619b2f6f5e6",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/b60ff497-0c81-423d-83a4-7619b2f6f5e6/wordmark-900.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/b60ff497-0c81-423d-83a4-7619b2f6f5e6/wordmark-900.webp",
  "original_filename": "wordmark-900.webp",
  "size": 49072,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:19:30Z"
}
